import Http from './http'

const BASE_URL = "/api/unit-fence"

export default {
  async index(opt) {
    return Http.get(`${BASE_URL}/unit-fence-map`, opt)
  },
  async post(data) {
    return Http.post(`${BASE_URL}/save-unit-fence-list`, data)
  }
}




// WEBPACK FOOTER //
// ./src/api/unitFence.js